import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import History from './pages/History';
import Login from './pages/Login';
import { getToken, getAuthInfo } from './api';

/**
 * RMG Container Reports Portal
 *
 * Routes:
 *   /                  → Login / customer selection
 *   /dashboard/:customer → Current day's report (auth required)
 *   /history/:customer   → Historical report browser (auth required)
 *   /history/:customer/:date → Specific historical report (auth required)
 */

/**
 * Route guard — checks auth token exists and customer access.
 * Non-admin users can only access their own customer's routes.
 */
function ProtectedRoute({ children }) {
  const { customer } = useParams();
  const token = getToken();
  const authInfo = getAuthInfo();

  // No token → go to login
  if (!token || !authInfo) {
    return <Navigate to="/" replace />;
  }

  // Non-admin trying to access another customer → go to their own dashboard
  if (!authInfo.is_admin && customer && authInfo.customer !== customer) {
    return <Navigate to={`/dashboard/${authInfo.customer}`} replace />;
  }

  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard/:customer"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/history/:customer"
          element={
            <ProtectedRoute>
              <History />
            </ProtectedRoute>
          }
        />
        <Route
          path="/history/:customer/:date"
          element={
            <ProtectedRoute>
              <Dashboard historical />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
